<template>
  <div class="bp-error-popup">
    <p class="bp-error-popup__text">{{ $t("errors.default.description") }}</p>
    <div class="bp-error-popup__buttons">
      <div class="button button--corner button--animated" @click="closePopup">
        {{ $t("errors.common.reload_button") }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "DefaultError",
  methods: {
    closePopup() {
      this.$store.commit("server_error/closeErrorPopup");
      window.location.reload();
    },
  },
};
</script>
